import { GatewayStatus } from 'constants/gatewayStatuses';

import { useGetList } from 'react-admin';
import { Controller, useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { FormHelperText } from 'shared/mui/FormHelperText/FormHelperText';
import { GatewayStatusIcon } from 'shared/mui/Icons/GatewayStatusIcon/GatewayStatusIcon';
import { InputLabel } from 'shared/mui/Labels/InputLabel/InputLabel';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { Select } from 'shared/mui/Select/Select';
import { GatewayStatus as GatewayStatusType } from 'types/embedded/gateway';

import { FormControlStyled, menuStyles } from './GatewayStatusSelectInput.styled';

export const GatewayStatusSelectInput = () => {
  const location = useLocation();
  const isCreatePage = location.pathname.endsWith('create');
  const { data: gatewayStatuses } = useGetList<GatewayStatusType>('gateway_statuses');

  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name="status"
      render={({ field }) => (
        <FormControlStyled error={!!errors.status} fullWidth>
          <InputLabel required shrink size="small">
            Статус
          </InputLabel>
          <Select
            MenuProps={{ sx: menuStyles }}
            fullWidth
            label="Статус"
            notched
            onChange={(value) => {
              field.onChange(value);
            }}
            required
            size="small"
            value={field.value || ''}
            variant="outlined"
          >
            {gatewayStatuses?.map((status) => {
              const isPilotDisabled = status.value === GatewayStatus.Pilot && isCreatePage;

              return (
                <MenuItem disabled={isPilotDisabled} key={status.id} value={status.id}>
                  <GatewayStatusIcon status={status.value as GatewayStatus} />
                  <span>
                    {isPilotDisabled
                      ? `${status.description} (доступен после создания шлюза)`
                      : status.description}
                  </span>
                </MenuItem>
              );
            })}
          </Select>
          {errors?.status?.message && (
            <FormHelperText>{errors?.status?.message as string}</FormHelperText>
          )}
        </FormControlStyled>
      )}
    />
  );
};
